import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class FilterDataService {
  private filterSubject = new BehaviorSubject<string>('');

  updateFilter(filter: string) {
    this.filterSubject.next(filter);
  }

  getFilterValue() {
    return this.filterSubject.asObservable();
  }
}
